import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../store/auth.js";
import Cookies from "js-cookie";

export default function NavBar() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const location = useLocation();

  function _logOut() {
    Cookies.remove("token");
    dispatch(logOut());
    navigate("/login");
  }

  function renderCategoryMessage() {
    if (location.pathname === "/category") {
      return (
        <Typography variant="body2" sx={{ color: "#fff", marginLeft: 2 }}>
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img src="/left-arrow.png" alt="Left Arrow" style={{ width: "1em", height: "1em", marginRight: "0.5em" }} />
              Go Back to Home
            </Box>
          </Link>
        </Typography>
      );
    }
    return null;
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
              FinanceTracker!
              {renderCategoryMessage()}
            </Link>
          </Typography>
          {isAuthenticated && (
            <>
              <Link to="/category" style={{ textDecoration: "none" }}>
                <Button color="inherit" sx={{ color: "#fff", marginRight: 2 }}>
                  Add Category
                </Button>
              </Link>
              <Typography sx={{ color: "#fff", marginRight: 2 }}>
                <i>{user.firstName} logged in</i>
              </Typography>
              <IconButton color="inherit" onClick={_logOut}>
                <LogoutIcon />
              </IconButton>
            </>
          )}
          {!isAuthenticated && (
            <>
              <Link to="/login" style={{ textDecoration: "none" }}>
                <Button color="inherit" sx={{ color: "#fff", marginRight: 2 }}>
                  Login
                </Button>
              </Link>
              <Link to="/register" style={{ textDecoration: "none" }}>
                <Button color="inherit" sx={{ color: "#fff" }}>
                  Register
                </Button>
              </Link>
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
